import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3033';
const base = `${apiUrl}/api/qrcodes`;

export const listQrCodes = () => axios.get(base).then((r) => r.data.qrcodes);
export const getQrCode = (id) => axios.get(`${base}/${id}`).then((r) => r.data.qrcode);
export const createQrCode = (payload) => axios.post(base, payload).then((r) => r.data);
export const updateQrCode = (id, payload) => axios.put(`${base}/${id}`, payload).then((r) => r.data.qrcode);
export const deleteQrCode = (id) => axios.delete(`${base}/${id}`).then((r) => r.data);
export const getQrCodeImage = (id, format) => axios.get(`${base}/${id}/image`, {params: {format}}).then((r) => r.data);
export const getQrCodeAnalytics = (id, params) => axios.get(`${base}/${id}/analytics`, {params}).then((r) => r.data);
export const getQrCodeCitiesForCountry = (id, country, params) => axios.get(`${base}/${id}/analytics/cities`, {params: {...params, country}}).then((r) => r.data.cities);
export const getQrCodeActivity = (id, period) => axios.get(`${base}/${id}/analytics/activity`, {params: {period}}).then((r) => r.data.activity);
export const generateQrCodePreview = (payload) => axios.post(`${base}/generate`, payload).then((r) => r.data);
